/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Delete_TitleInputs */

const en_manual_qc_delete_title = /** @type {(inputs: Manual_Qc_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Issue`)
};

const fr_manual_qc_delete_title = /** @type {(inputs: Manual_Qc_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer l'incident`)
};

const de_manual_qc_delete_title = /** @type {(inputs: Manual_Qc_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem löschen`)
};

const it_manual_qc_delete_title = /** @type {(inputs: Manual_Qc_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina problema`)
};

const ru_manual_qc_delete_title = /** @type {(inputs: Manual_Qc_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить проблему`)
};

const es_manual_qc_delete_title = /** @type {(inputs: Manual_Qc_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar problema`)
};

const zh_cn2_manual_qc_delete_title = /** @type {(inputs: Manual_Qc_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除问题`)
};

const ja_manual_qc_delete_title = /** @type {(inputs: Manual_Qc_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題を削除`)
};

const hi_manual_qc_delete_title = /** @type {(inputs: Manual_Qc_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समस्या हटाएं`)
};

const pt_pt2_manual_qc_delete_title = /** @type {(inputs: Manual_Qc_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir problema`)
};

/**
* | output |
* | --- |
* | "Delete Issue" |
*
* @param {Manual_Qc_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_delete_title = /** @type {((inputs?: Manual_Qc_Delete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Delete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_delete_title(inputs)
	if (locale === "de") return de_manual_qc_delete_title(inputs)
	if (locale === "it") return it_manual_qc_delete_title(inputs)
	if (locale === "ru") return ru_manual_qc_delete_title(inputs)
	if (locale === "es") return es_manual_qc_delete_title(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_delete_title(inputs)
	if (locale === "ja") return ja_manual_qc_delete_title(inputs)
	if (locale === "hi") return hi_manual_qc_delete_title(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_delete_title(inputs)
	return en_manual_qc_delete_title(inputs)
});